import { apiAction, API_SUCCESS, API_ERROR } from "../dux/api";
import { apiCallComplete, apiCallStart } from "../dux/apiStatus";
import { SAVE_PROFILE } from "../dux/profile";
import { openSnackbar } from "../dux/snackbar";
import { getSaveUserDetailsUrl } from "../helpers/apiEndPoints";
import { updateUser } from "../helpers/sessionStorageHelper";

const profile = () => (next) => (action) => {
  next(action);

  if (action.type === SAVE_PROFILE) {
    const { firstName, lastName, emailAddress, mobileNumber } = action.payload;
    next(apiCallStart({ api: "saveProfile" }));
    next(
      apiAction({
        url: getSaveUserDetailsUrl(),
        feature: SAVE_PROFILE,
        method: "POST",
        data: {
          first_name: firstName,
          last_name: lastName,
          email_address: emailAddress,
        },
        meta: { firstName, lastName, emailAddress, mobileNumber },
      })
    );
  }

  if (action.type === `${SAVE_PROFILE} ${API_SUCCESS}`) {
    next(apiCallComplete({ api: "saveProfile" }));
    // Update session storage with the correct field names
    updateUser({
      first_name: action.meta.firstName,
      last_name: action.meta.lastName,
      email_address: action.meta.emailAddress,
      mobile_number: action.meta.mobileNumber,
    });
    next(
      openSnackbar({
        message: "User details are updated successfully.",
      })
    );
  }

  if (action.type === `${SAVE_PROFILE} ${API_ERROR}`) {
    next(apiCallComplete({ api: "saveProfile" }));
  }
};

export default profile;
